export const setFieldValue = (formName, name, value) => ({
  type: 'SET_FIELD_VALUE',
  formName,
  name,
  value
});
